import React from 'react';
import { css } from '@emotion/react';

import { Link } from 'react-router-dom';

import { RequestForm } from './forms/RequestForm';
import { Header } from 'screens/booker/components/Header';
import { Heading } from 'screens/booker/components/Heading';
import { routes } from 'routes';
import { theme } from 'styles/theme';

export const ScreenAddRequest = () => {
	// TODO vyfiltrovat data do formulare

	return (
		<div>
			<Header>
				<Heading
					left={
						<div>
							{/* <div>
								<Link to={routes.booker.request}>{'<-'} Zpět</Link>
							</div> */}
							<h1
								css={css`
									font-size: 24px;
									line-height: 36px;
									font-weight: normal;
									margin-bottom: 0;
									// margin-top: 16px;

									display: flex;
									align-items: center;
									gap: 12px;
								`}
							>
								<Link
									to={routes.booker.request}
									css={css`
										color: ${theme.color.text[300]};

										&:hover {
											text-decoration: none;
										}
									`}
								>
									Poptávky
								</Link>
								<span
									css={css`
										color: ${theme.color.text[300]};
									`}
								>
									-&gt;
								</span>
								Přidat poptávku
							</h1>
						</div>
					}
				></Heading>
			</Header>
			<div
				css={css`
					display: flex;
					padding: 32px;
					width: 580px;
					flex-direction: column;
				`}
			>
				<RequestForm />
			</div>
		</div>
	);
};
